export const ACTIVE_REQUISITE_EXISTS_MESSAGE =
  'Active requisite already exists';
